module.exports = __webpack_public_path__ + "img/login-bg.3316a24f.png";